import {
    RESOURCES_REQUESTED,
    RESOURCES_SUCCEEDED,
    RESOURCES_FAILED,
} from './constants';

export function resourcesRequested() {
    return {
        type: RESOURCES_REQUESTED,
    };
}

export function resourcesSucceeded(resources) {
    return {
        type: RESOURCES_SUCCEEDED,
        resources,
    };
}

export function resourcesFailed(error) {
    return {
        type: RESOURCES_FAILED,
        error,
    };
}
